import { useEffect, useCallback } from 'react'
import { useLocation } from 'react-router-dom'

export const useScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    // Плавне прокручування вгору з анімацією
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    }

    // Невелика затримка для забезпечення завантаження контенту
    const timeoutId = setTimeout(scrollToTop, 10)

    return () => clearTimeout(timeoutId)
  }, [pathname])
}

// Додаткова функція для програмного прокручування
export const useScrollToTopManual = () => {
  const scrollToTop = useCallback((behavior: ScrollBehavior = 'smooth') => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior,
    })
  }, [])

  return scrollToTop
}
